// extracted by mini-css-extract-plugin
module.exports = {"root":"page_root__q6Nom","main":"page_main__bszR1"};